import update from 'immutability-helper';
import PropTypes from 'prop-types';
import React from 'react';
import { PlaylistItem } from '..';
import { Box } from '../layout';
import { Switch } from '../widgets';
import './styles.scss'
import selectTableHOC from "react-table/lib/hoc/selectTable";
import 'react-table-v6/react-table.css'
import Table from "react-table";
import { EditableLabel } from "../../components";
import {Button,  Icon } from "../../components/widgets";


const SelectTable = selectTableHOC(Table);

class PlaylistItemEdit extends React.Component {
    static defaultProps = {
        keyField: "id"
    };

    static propTypes = {
        handleSelectionOn: PropTypes.func.isRequired,
        onReorder: PropTypes.func.isRequired,
    };


    constructor(props) {
        super(props);
        this.state = {
            playlist: props.playlist,
            isLoading: false,
            searchInput: '',
            filteredResults: [],
            selected: null,
            selectAll: false,
            selection: props.selectionMain,
            keys: [],
            editing: true,
            inputedValue: '',
            selectedItem: false,
            pItems: props.items,
            selectedItems: [],
            

        };
    }

    componentWillReceiveProps(newProps) {
        if (this.props.items.length !== newProps.items.length) {
            this.setState({ items: newProps.items });
        }
    }


    toggleSelection = (key, shift, row) => {
        // start off with the existing state
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);

        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            // it does not exist so add it
            selection.push(key);
        }
        // update the state
        this.props.handleSelectionOn(selection)
        this.setState({ selection });


    };


    toggleAll = () => {
        const { keyField } = this.props;
        const selectAll = !this.state.selectAll;
        const selection = [];

        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            // we just push all the IDs onto the selection array
            currentRecords.forEach(item => {
                selection.push(`select-${item._original[keyField]}`);
            });
        }
        this.props.handleSelectionOn(selection)
        this.setState({ selectAll, selection });
    };


    isSelected = key => {
        return this.state.selection.includes(`select-${key}`);
    };

    rowFn = (state, rowInfo, column, instance) => {
        const { selection } = this.state;

        return {
            onClick: (e, handleOriginal) => {
                console.log("It was in this row:", rowInfo);

                // IMPORTANT! React-Table uses onClick internally to trigger
                // events like expanding SubComponents and pivots.
                // By default a custom 'onClick' handler will override this functionality.
                // If you want to fire the original onClick handler, call the
                // 'handleOriginal' function.
                if (handleOriginal) {
                    handleOriginal();
                }
            },
            style: {
                background:
                    rowInfo &&
                    selection.includes(`select-${rowInfo.original.id}`) &&
                    "#ccd1d1 "
            }
        };
    };
    searchItems = (searchValue) => {
        this.setState({ searchInput: searchValue });
    
        if (this.state.searchInput) {
            const filteredData = this.state.pItems.filter((item) => {
                const itemName = Object.values(item.item.name).join('').toLowerCase();
                const tagsMatch = item.item.tags.some(tag => tag.toLowerCase().includes(this.state.searchInput.toLowerCase()));
                console.log("tagsMatch", tagsMatch)
                return itemName.includes(this.state.searchInput.toLowerCase()) || tagsMatch;
            });

            console.log("filteredData", filteredData)
    
            this.setState({ filteredResults: filteredData });
        } else {
            this.setState({ filteredResults: this.state.pItems });
        }
    }
    
    // searchItems = (searchValue) => {
    //     this.setState({ searchInput: searchValue });
    
    //     if (this.state.searchInput !== '') {
    //         const filteredData = this.state.pItems.filter((item) => {
    //             const itemName = Object.values(item.item.name).join('').toLowerCase();
    //             const tagsMatch = item.item.tags.some(tag => tag.toLowerCase().includes(this.state.searchInput.toLowerCase()));
    //             console.log("tagsMatch", tagsMatch)
    //             return itemName.includes(this.state.searchInput.toLowerCase()) || tagsMatch;
    //         });
    
    //         this.setState({ filteredResults: filteredData });
    //     } else {
    //         this.setState({ filteredResults: this.state.pItems });
    //     }
    // }
    

    renderItemName = (cellInfo) => {
        return (
            <h5>
                <EditableLabel value={cellInfo.original.item.name} onChange={this.props.onAssetChange} />
            </h5>
        )
    }

    selectionChange = (item) => {
        var idObj = this.state.pItems.find(x => x.id === item.id);

        if (this.state.selectedItems.includes(item)) {
            console.log("object removed", this.state.selectedItems)

            this.setState({
                selectedItems: [...this.state.selectedItems].filter((item) => item.id !== item.id),
            });
        }
        else {
            this.setState({ selectedItems: this.state.selectedItems.concat(idObj) })
            console.log("object added", this.state.selectedItems)


        }



    }


    sortMethods = {
        none: { method: (a, b) => null },
        ascending: { method: (a, b) => (a.name > b.name ? -1 : 1) },
        descending: { method: (a, b) => (a.name > b.name ? 1 : -1) },
    };

    handlePositionChange = (e, item) => {
        return this.props.onPositionChange(item.item.id, e.currentTarget.value)
    }

    savePositionComponent() {
        if (this.props.editMode) {
            return (
                <Box direction="row" className="button-group">
                    <Button onClick={this.props.handleOrderSave}>Save New Positions</Button>
                </Box>
            );
        }
    }

    render() {
        const { selectAll, playlist, searchInput, pItems, filteredResults } = this.state;
        const columns = [
            {
                Header: () => <h5 >Select All </h5>,
                headerStyle: {
                    textAlign: 'left',
                    border: "1px solid transparent",
                    background: 'white',
                    color: '#21618c'
                },
                accessor: 'item.name',
                Cell: this.renderItemName,

            },

            // {
            //     Header: () => <div></div>,
            //     sortable: false,
            //     filterable: false,

            //     headerStyle: {
            //         textAlign: 'left',
            //     },

            //     Cell: props => {
            //         return (
            //             <Box direction="row" className="position-editor">
            //                 <input type="text"
            //                     onChange={(e) => this.handlePositionChange(e, props.original)}
            //                     defaultValue={props.original.position} />
            //             </Box>
            //         )
            //     },

            // },

            {
                Header: () => <div></div>,
                sortable: false,
                filterable: false,
                background: 'white',


                headerStyle: {
                    textAlign: 'left',

                },




            },


        ]
        console.log("this.props.item", this.props.items)

        return (
            <div>

                <div className='flex flex-jc-sb ai-i-c hide-for-mobile'
                    style={{ 'margin-bottom': '0.5rem' }}>

                    {this.props.adding == false && this.props.replacing == false && <div style={{ width: "36%" }} className="input-group">
                        <input

                            className="input-group-field"
                            type="text"
                            value={searchInput}
                            placeholder="Search an Item"
                            onChange={(e) => this.searchItems(e.target.value)}
                        />
                        <span className="input-group-label">
                            <Icon title="Search" name="search" size="1rem" />
                        </span>
                    </div>}
                    {this.props.adding == false && this.props.replacing == false &&
                        <div className='flex ai-i-c'>
                            <Switch
                                label="Subscribe to new content feeds automatically:"
                                formId="subscribe-feeds"
                                className="mr--sm"
                                checked={this.props.playlist.auto_add_feeds}
                                onChange={this.props.handleSubscriptionChange} />

                            <Switch
                                label="Show Thumbnails:"
                                formId="show-thumbnails"
                                checked={this.props.showThumbnailsState}
                                onChange={this.props.showThumbnails} />
                        </div>
                    }
                </div>


                {this.props.adding == false && this.props.replacing == false && <div className='flex flex-jc-sb ai-i-c hide-for-desktop'
                    style={{ 'margin-bottom': '1.5rem' }}
                >
                    <div className="input-group">
                        <input
                            className="input-group-field"
                            type="text"
                            value={searchInput}
                            placeholder="Search an Item"
                            onChange={(e) => this.searchItems(e.target.value)}
                        />
                        <span className="input-group-label">
                            <Icon title="Search" name="search" size="1rem" />
                        </span>
                    </div>


                </div>}



                {this.props.filterOptionsEnabled == true &&
                    <React.Fragment>
                        {
                            this.props.adding == false &&
                            <div className='flex ai-i-c'>
                                <select
                                    style={{ width: '10rem' }}
                                    defaultValue='null'
                                    onChange={(e) => this.props.handleSwitchItemType(e.target.value)}>
                                    <option value="null">Default</option>
                                    <option value="IMAGE">IMAGE</option>
                                    <option value="VIDEO">VIDEO</option>
                                    <option value="WEB">WEB</option>
                                    <option value="URL">URL</option>
                                    <option value="PDF">PDF</option>
                                    <option value="AQI_VEDA">AQI VEDA</option>

                                </select>

                                <select
                                    style={{ width: '10rem' }}
                                    defaultValue='null'
                                    onChange={(e) => this.props.handleSortType(e.target.value)}>
                                    <option value="none">Default</option>
                                    <option value="ascending">Ascending</option>
                                    <option value="descending">Descending</option>
                                </select>

                                <button className='button style-button-mobile'>
                                    {this.props.sortState == 'ascending' && <i
                                        onClick={() => this.props.handleSortType('descending')}
                                        className="fa-solid fa-arrow-up-z-a mr-1"></i>}
                                    {this.props.sortState == 'none' && <i
                                        onClick={() => this.props.handleSortType('ascending')}
                                        className="fa-solid fa-arrow-down-z-a mr-1"></i>}
                                    {this.props.sortState == 'descending' && <i
                                        onClick={() => this.props.handleSortType('ascending')}
                                        className="fa-solid fa-arrow-down-z-a mr-1"></i>}
                                </button>
                            </div>
                        }
                    </React.Fragment>
                }

                {this.props.editMode ?

                    <div>
                    {/* {this.savePositionComponent()} */}

                        {searchInput === "" ? (
                            <SelectTable
                                keyField="id"
                                columns={columns}
                                data={this.props.items}
                                defaultPageSize={this.props.items.length + 1}
                                noDataText={"Loading Items .."}
                                loading={this.state.isLoading}
                                ref={r => (this.checkboxTable = r)}
                                toggleSelection={this.toggleSelection}
                                selectAll={selectAll}
                                selectType="checkbox"
                                toggleAll={this.toggleAll}
                                isSelected={this.isSelected}
                                getTrProps={this.rowFn}
                                showPagination={false}
                            />
                        )

                            : (
                                <SelectTable
                                    keyField="id"
                                    columns={columns}
                                    data={filteredResults}
                                    defaultPageSize={filteredResults.length + 1}
                                    noDataText={"Loading Items .."}
                                    loading={this.state.isLoading}
                                    ref={r => (this.checkboxTable = r)}
                                    toggleSelection={this.toggleSelection}
                                    selectAll={selectAll}
                                    selectType="checkbox"
                                    toggleAll={this.toggleAll}
                                    isSelected={this.isSelected}
                                    getTrProps={this.rowFn}
                                    showPagination={false}
                                />

                            )}
                    </div>
                    :
                    <div>
                        {this.props.sortType != null ?
                            (
                                <div>
                                    {this.props.items.filter(item => {
                                        if (this.props.sortType === null) {
                                            return this.props.items;
                                        } else if (item.item.type === this.props.sortType) {
                                            return this.props.items;
                                        }
                                    }).sort(this.sortMethods[this.props.sortState].method)
                                        .map((item, index) => (
                                            <PlaylistItem key={item.id}
                                                index={index}
                                                item={item}
                                                thumbnails={this.props.showThumbnailsState}
                                                adding={this.props.adding}
                                                editMode={this.props.editMode}
                                                onChange={this.props.onChange}
                                                onDelete={this.props.onDelete}
                                                onPositionChange={this.props.onPositionChange}
                                                onSelect={this.props.onSelect}
                                                moveItem={this.props.moveItem}
                                                selectedItem={this.props.onSelectAll}
                                                dropItem={this.props.dropItem} />
                                        ))
                                    }
                                </div>
                            )
                            :


                            <div>
                                {this.props.items.filter(item => {
                                    const itemName = item.item.name.toLowerCase();
                                    const tagsMatch = item.item.tags.some(tag => tag.toLowerCase().includes(searchInput.toLowerCase()));
                            
                                    if (searchInput === '') {
                                        return true; // Return all items when searchInput is empty
                                    } else if (itemName.includes(searchInput.toLowerCase()) || tagsMatch) {
                                        return true; // Return items where name or tags match the searchInput
                                    }
                                    return false; // Exclude items that don't match the search criteria
                                }).sort(this.sortMethods[this.props.sortState].method)
                                    .map((item, index) => (
                                        <PlaylistItem key={item.id}
                                            index={index}
                                            item={item}
                                            thumbnails={this.props.showThumbnailsState}
                                            adding={this.props.adding}
                                            editMode={this.props.editMode}
                                            onChange={this.props.onChange}
                                            onDelete={this.props.onDelete}
                                            onPositionChange={this.props.onPositionChange}
                                            editPostion={this.props.editPostion}
                                            onSelect={this.props.onSelect}
                                            moveItem={this.props.moveItem}
                                            selectedItem={this.props.onSelectAll}
                                            selectionChange={this.selectionChange}
                                            selectedItems={this.state.selectedItems}
                                            handleUserReport={this.props.handleUserReport}
                                            reportActivityStatus={this.props.reportActivityStatus}
                                            dropItem={this.props.dropItem} 
                                            isTimedPlayback={this.props.isTimedPlayback}
                                            />
                                    ))
                                }
                            </div>

                        }
                    </div>



                }</div>

        )
    }
}

export default PlaylistItemEdit;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PlaylistView/main.js